import { MtTask } from "server/models"
import { VIEW, ADD, EDIT, DELETE } from "const"
import { hasAccess, hasProjectAccess } from "client/utils"
import {
    PRM_TASK,
    TaskObserverList,
    TaskParticipantList,
    UserData,
} from "client/store"

// eslint-disable-next-line import/prefer-default-export
export const GetTaskAccess = (
    task: MtTask,
    taskParticipantList: TaskParticipantList,
    taskObserverList: TaskObserverList,
    userData: UserData,
) => {
    const projectId = task ? task.projectId : null

    const viewAccountAccess = hasAccess(PRM_TASK, VIEW)
    const editAccountAccess = hasAccess(PRM_TASK, EDIT)
    const addAccountAccess = hasAccess(PRM_TASK, ADD)
    const deleteAccountAccess = hasAccess(PRM_TASK, DELETE)

    const viewProjectAccess = hasProjectAccess(PRM_TASK, VIEW, task && task.projectId)
    const editProjectAccess = hasProjectAccess(PRM_TASK, EDIT, projectId)
    const addProjectAccess = hasProjectAccess(PRM_TASK, ADD, projectId)
    const deleteProjectAccess = hasProjectAccess(PRM_TASK, DELETE, projectId)

    if (!task) return {}

    const isCreator = task.creator === userData.userId
    const isResponsible = task.responsible === userData.userId

    const isParticipant = taskParticipantList
        && taskParticipantList[task.id]
        && taskParticipantList[task.id].includes(userData.userId)

    const isObserver = taskObserverList
        && taskObserverList[task.id]
        && taskObserverList[task.id].includes(userData.userId)

    const viewAccess = projectId ? viewProjectAccess : viewAccountAccess
    const editAccess = projectId ? editProjectAccess : editAccountAccess
    const addAccess = projectId ? addProjectAccess : addAccountAccess
    const deleteAccess = projectId ? deleteProjectAccess : deleteAccountAccess

    const allowedToView = viewAccess || isCreator || isResponsible || isParticipant || isObserver
    const allowedToEdit = editAccess || isCreator
    const allowedToDelete = deleteAccess || isCreator

    return {
        isCreator,
        isResponsible,
        isParticipant,
        isObserver,

        allowedToView,
        addAccess,
        allowedToEdit,
        allowedToDelete,
    }
}
